
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/[blogPage]",
      function () {
        return require("private-next-pages/blogs/[blogPage]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/[blogPage]"])
      });
    }
  